import { createAsyncThunk } from "@reduxjs/toolkit";
import { scoutsRepository } from "api/scoutsRepository";
import { validationSearchUserName } from "common/helpers/validators/validationSearchUserName";
import { ThunkApiType } from "common/interfaces/common";
import { Staff, StaffFilters, StaffResponce } from "../../common/interfaces/staff";

export const getClubsScoutsByFilter = createAsyncThunk<StaffResponce, StaffFilters, ThunkApiType>(
  "clubsScouts/byFilter",
  async (filters, { rejectWithValue }) => {
    validationSearchUserName(filters.FullName);

    return await scoutsRepository.fetchByFilter(filters).catch((error) => rejectWithValue({ error }));
  }
);

export const getClubsScoutById = createAsyncThunk<Staff, Staff["Id"], ThunkApiType>(
  "clubsBreede/byId",
  async (id, { rejectWithValue }) => {
    return await scoutsRepository.fetchById(id).catch((error) => rejectWithValue({ error }));
  }
);

export const publishClubsScout = createAsyncThunk<void, Staff, ThunkApiType>(
  "clubsScout/publish",
  async (id, { rejectWithValue }) => {
    return await scoutsRepository.publish(id).catch((error) => rejectWithValue({ error }));
  }
);

export const draftClubsScout = createAsyncThunk<void, Staff, ThunkApiType>(
  "clubsScout/draft",
  async (id, { rejectWithValue }) => {
    return await scoutsRepository.draft(id).catch((error) => rejectWithValue({ error }));
  }
);

export const deleteClubsScout = createAsyncThunk<void, Staff["Id"], ThunkApiType>(
  "clubsScout /delete",
  async (id, { rejectWithValue }) => {
    return await scoutsRepository.deleteById(id).catch((error) => rejectWithValue({ error }));
  }
);
